module.exports = __webpack_public_path__ + "img/hic-colorectal-cancer-female.5528731f.png";